// Une rubrique d'insight dans une liste de définition (`<dl>`).
export function Part({ label, text }: { label: string; text: string }) {
  return (
    <div>
      <dt>{label}</dt>
      <dd>{text}</dd>
    </div>
  );
}
